import { overviewRegistry } from "../overview_registry.js";
import { getTopTip } from "../tip_registry.js";

function TipsContent() {
  const tip = getTopTip();
  if (!tip) {
    return (
      <div className="text-sm text-muted-foreground">No tips available</div>
    );
  }
  return <tip.component />;
}

overviewRegistry.register({
  type: "tips",
  order: 0,
  title: "Getting started",
  content: TipsContent,
});
